import React, { useEffect, useReducer } from 'react';
import { useForm } from 'react-hook-form';
// import { useHistory } from 'react-router';
import { disciplineService } from './disciplineService';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';

const initialState = {
    isLoading: false,
    isSubmitting: false,
    serverCommunication: undefined,
    disciplineId: undefined
}

const ACTIONS = {
    DISCIPLINE_CREATE_CALL: 'DISCIPLINE_CREATE_CALL',
    DISCIPLINE_CREATE_SUCCESS: 'DISCIPLINE_CREATE_SUCCESS',
    DISCIPLINE_CREATE_ERROR: 'DISCIPLINE_CREATE_ERROR'
}

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.DISCIPLINE_CREATE_CALL:
            return {
                ...state,
                isLoading: true
            };
        case ACTIONS.DISCIPLINE_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                disciplineId: action.data.id
            };
        case ACTIONS.DISCIPLINE_CREATE_ERROR:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                serverCommunication: action.data
            }
        default:
            throw new Error(`No action of type ${action.type} found in reducer.`)
    }
}

function DisciplineCreate() {

    const navigate = useNavigate();

    const {contextValue } = useAuth();



    const [state, dispatch] = useReducer(reducer, initialState);
    const { register, handleSubmit, formState: { errors } } = useForm();
    // const history = useHistory();

    useEffect(() => {
        if (state.disciplineId) {
            // history.push(`/discipline/${state.disciplineId}`);
            navigate(`/discipline/${state.disciplineId}`);
        }
    }, [state.disciplineId, navigate]);

    function handleDisciplineCreate(discipline) {

        contextValue.showLoader();
        contextValue.updateLoaderText("Creating discipline...");
        dispatch({ type: ACTIONS.DISCIPLINE_CREATE_CALL });
        disciplineService.createDiscipline({
            ...discipline
        })
        .then(response => 
            {
                toast.success("Discipline created successfully");
                dispatch({ type: ACTIONS.DISCIPLINE_CREATE_SUCCESS, data: response.data })
            }
        
        )
        .catch(error =>{
            toast.error("Error creating discipline");
            dispatch({ type: ACTIONS.DISCIPLINE_CREATE_ERROR, data: error.response.data })
        })
        .finally(() => contextValue.hideLoader());
    }

    return (
        <form onSubmit={handleSubmit(handleDisciplineCreate)}>
        <div className="mb-3">
            <label htmlFor="newDisciplineName" className="form-label">Name</label>
            <input type="text" className="form-control" id="newDisciplineName" autoComplete='off' {...register('name', {required: true})}/>
            {errors.name?.type === 'required' && <div className='text-danger form-text'>Name is required</div>}
        </div>
        {state.serverCommunication && <p className='text-danger'>{state.serverCommunication.messages}</p>}
        <button className='btn btn-success text-white w-100' type='submit'>Create</button>
    </form>
    );
}

export default DisciplineCreate;